import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
export default function AuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');

    if (token) {
      // 1. Проверяем, не был ли это вход "только для SSO"
      const isSSOOnly = sessionStorage.getItem('sso_only_mode') === 'true';
      const ssoReturnUrl = sessionStorage.getItem('sso_return_url');

      if (isSSOOnly && ssoReturnUrl) {
        sessionStorage.removeItem('sso_only_mode');
        sessionStorage.removeItem('sso_return_url');

        // ВАЖНО: Используем URLSearchParams, чтобы не сломать существующие параметры sso
        const url = new URL(ssoReturnUrl);
        url.searchParams.set('temp_token', token);

        // Переходим на /sso с temp_token в URL
        window.location.href = url.toString();
        return;
      }

      // 2. Старая логика редиректа после логина в Points
      localStorage.setItem('hatchup_token', token);
      const ssoRedirect = localStorage.getItem('sso_redirect');
      if (ssoRedirect) {
        localStorage.removeItem('sso_redirect'); // Очищаем, чтобы не сработало потом случайно
        window.location.href = ssoRedirect; // Уходим на внешний сервис
      } else {
        navigate('/'); // Обычный вход
      }
    } else {
      // Если токена нет, что-то пошло не так. Возвращаем на страницу входа.
      navigate('/login');
    }
  }, [searchParams, navigate]);

  return <div>Загрузка...</div>; // Пока идет обработка, показываем это сообщение
}